import { locationsAdapter } from "@/lib/adapters/firestore";
import { Tournament } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { useTournament } from "./useTournament";

export const useTournamentLocations = (tournamentId: Tournament["id"]) => {
  const { data: tournament, isLoading: tournamentLoading } =
    useTournament(tournamentId);

  return useQuery({
    queryKey: ["tournamentLocations", tournamentId],
    queryFn: async () => {
      if (!tournament?.locationIds || tournament.locationIds.length === 0) {
        return [];
      }

      return locationsAdapter.getAll({
        filters: [
          {
            field: "__name__",
            operator: "in",
            value: tournament.locationIds,
          },
        ],
      });
    },
    enabled: !tournamentLoading && !!tournament,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
